module.exports = __webpack_public_path__ + "img/47.da8c5363.jpg";